import { render, staticRenderFns } from "./listPaginator.vue?vue&type=template&id=b8a89cbc&"
import script from "./listPaginator.vue?vue&type=script&lang=js&"
export * from "./listPaginator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports